import { produce } from "immer";

const initialState = {
  detail: {},
  loading: false,
  permission: [],
  defaultPermission: [],
  loadingPermission: false,
  loadingPermissionUser: false,
};

const UserGroupDetailReducer = produce((draft = initialState, action = {}) => {
  switch (action.type) {
    case "FETCH_USER_GROUP_DETAIL":
      draft.loading = true;
      return draft;
    case "FETCH_USER_GROUP_DETAIL_SUCCESS":
      draft.detail = action.payload;
      draft.loading = false;
      return draft;
    case "FETCH_USER_GROUP_DETAIL_FAIL":
      draft.loading = false;
      return draft;
    case "CLEAR_USER_GROUP_DETAIL":
      draft.detail = {};
      return draft;
    case "FETCH_PERMISSION_BY_GROUP":
      draft.loadingPermission = true;
      return draft;
    case "FETCH_PERMISSION_BY_GROUP_SUCCESS":
      draft.loadingPermission = false;
      draft.permission = action.payload;
      return draft;
    case "FETCH_PERMISSION_BY_GROUP_FAIL":
      draft.loadingPermission = false;
      return draft;
    case "FETCH_PERMISSION_USER":
      draft.loadingPermissionUser = true;
      return draft;
    case "FETCH_PERMISSION_USER_SUCCESS":
      draft.loadingPermissionUser = false;
      draft.defaultPermission = action.payload;
      return draft;
    case "FETCH_PERMISSION_USER_FAIL":
      draft.loadingPermissionUser = false;
      return draft;
    case "CLEAR_PERMISSION_USER":
      draft.defaultPermission = {};
      return draft;
    default:
      return draft;
  }
});

export default UserGroupDetailReducer;
